import { array2Object, downloadBlob } from '@bigo/helpers';
import XLSX, { BookType } from 'xlsx';

import { Option } from '@/constants/option';

/** 选项转化为文本映射对象 */
export function optionsToMap<K extends string | number>(options: Option<K>[]) {
  return array2Object(options, 'value', 'label') as Record<K, string>;
}

/**
 * 把 html 表格导出成 excel 或 csv
 * @param {} elem dom 元素
 */
export function exportTable(elem: Element, bookType: BookType = 'xlsx', name = '') {
  const workbook = XLSX.utils.book_new();
  const ws2 = XLSX.utils.table_to_sheet(elem);

  XLSX.utils.book_append_sheet(workbook, ws2, 'Sheet1');

  const wData = XLSX.write(workbook, { bookType, type: 'array' });
  const blob = new Blob([wData], { type: 'application/octet-stream' });

  downloadBlob(blob, name);
}

/**
 * Blob转Json
 * @param {Blob} blob
 * @return {any}
 */
export function blobToJson(blob: Blob) {
  return new Promise((resolveLocal, rejectLocal) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      resolveLocal(e.target?.result);
    };
    reader.onerror = (e) => {
      rejectLocal(e);
    };
    reader.readAsText(blob);
  });
}
